import React, { useState } from "react";
import {
  question11,
  question12,
  question13,
  question14,
  question15,
} from "assets/images";
import CustomButton from "components/form";

const Question2 = ({ bodyShapeContent,setBodyShapeContent,addOrUpdateQuestion,buttonLoaders,errors  }) => {
 
console.log(bodyShapeContent,"bodyShapeContent")
  const handleInputChange = (index, field, value) => {
    const updatedContent = [...bodyShapeContent.bodyShapeContent];
    updatedContent[index][field] = value;
    setBodyShapeContent({
      ...bodyShapeContent,
      bodyShapeContent: updatedContent,
    });
  };
  return (
    <>
      <div className="form_field page_title">
        <label className="label">Screen Title</label>
        <input
          type="text"
          className="form-control input"
          placeholder="Enter Title"
          value={bodyShapeContent.bodyShapeContentHeading}
          onChange={(e) =>
            setBodyShapeContent({
              ...bodyShapeContent,
              bodyShapeContentHeading: e.target.value,
            })
          }
        />
              {errors.bodyShapeContentHeading && (
          <span className="error">{errors.bodyShapeContentHeading}</span>
        )}
      </div>
      <h4>Options to Answer</h4>
      <div className="card_wrap pick_shape">
        {bodyShapeContent.bodyShapeContent.map((shape, index) => (
          <div className="item" key={shape.shape}>
            <div className="_card">
              <img
                src={[question11, question12, question13, question14, question15][index]}
                alt={shape.shape}
              />
            </div>
            <div className="input_content">
              <span className="card_tag">{shape.shape}</span>
              <div className="form_field">
                <input
                  type="text"
                  className="form-control input"
                  placeholder="Enter Title"
                  value={shape.title}
                  onChange={(e) =>
                    handleInputChange(index, "title", e.target.value)
                  }
                />
                {errors[`bodyShapeContentTitle${index}`] && (
                  <span className="error">{errors[`bodyShapeContentTitle${index}`]}</span>
                )}


              </div>
              <div className="form_field">
                <input
                  type="text"
                  className="form-control input"
                  placeholder="Enter Description"
                  value={shape.description}
                  onChange={(e) =>
                    handleInputChange(index, "description", e.target.value)
                  }
                />
                  {errors[`bodyShapeContentDescription${index}`] && (
                  <span className="error">{errors[`bodyShapeContentDescription${index}`]}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="button_wrap">
        <CustomButton ref={buttonLoaders} onClick={addOrUpdateQuestion}>Save</CustomButton>
      </div>
    </>
  );
};

export default Question2;
